/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { Badge, Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import Session from './Session';

const CompletedSession = props => {

    // context
    const { theme, colors } = useContext(ThemeContext);

    // states
    const [isCompletedSessionOpen, setIsCompletedSessionOpen] = useState(false);
    const [sessionList, setSessionList] = useState([]);


    // utility functions
    const toggleCompletedSession = () => setIsCompletedSessionOpen(!isCompletedSessionOpen);

    // useEffect
    useEffect(() => {
        try {
            if (props.sessions) {
                setSessionList(props.sessions);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User CompletedSession useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.sessions])

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card} id="completedSessions">
            <div className="row px-3" onClick={toggleCompletedSession} style={{ cursor: "pointer" }}>
                <span id="completedSessions" style={theme.headingBold}>Completed Sessions <Badge style={{ backgroundColor: colors.primary }}>{sessionList.length}</Badge> </span>

                {
                    sessionList.length ?
                        isCompletedSessionOpen
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                        : null
                }

            </div>

            <Collapse isOpen={sessionList.length ? isCompletedSessionOpen : false}>
                <hr />
                {
                    sessionList.map((item, index) => (
                        <Session key={index} selectedTimeZone={props.selectedTimeZone} handleModal={props.handleModal} detail={item} type="Completed" index={index} />
                    ))
                }
            </Collapse>

        </div>
    )
}

export default CompletedSession;